import { homePageUrl, brandName, venture } from '../../config'

function breadcrumbSchema ({ url, base, gameTitle, categories }) {
  const categoriesDictionary = categories && categories.reduce(function (map, obj) {
    map[obj.slug] = obj.name
    return map
  }, {})

  const scriptBaseObject = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [{
      '@type': 'ListItem',
      position: 1,
      item: {
        '@id': base,
        name: brandName
      }
    }]
  }

  const pathsToReplace = {
    ballycasinonj: '/nj/',
    ballybetaz: '/'
  }
  const pathToReplace = pathsToReplace[venture] || homePageUrl
  const idsFromUrl = url.replace(pathToReplace, '/').split('/').splice(3)
  const [categoryId, id, item3] = idsFromUrl

  if (categoryId) {
    scriptBaseObject.itemListElement.push({
      '@type': 'ListItem',
      position: 2,
      item: {
        '@id': base + (pathsToReplace[venture] || homePageUrl) + categoryId,
        name: categoriesDictionary[categoryId]
      }
    })
  }
  if (id) {
    scriptBaseObject.itemListElement.push({
      '@type': 'ListItem',
      position: 3,
      item: {
        '@id': base + homePageUrl + categoryId + '/' + id,
        name: gameTitle || categoriesDictionary[id]
      }
    })
  }
  if (item3) {
    scriptBaseObject.itemListElement.push({
      '@type': 'ListItem',
      position: 4,
      item: {
        '@id': base + homePageUrl + categoryId + '/' + item3,
        name: gameTitle || categoriesDictionary[item3]
      }
    })
  }
  return JSON.stringify(scriptBaseObject)
}

export const gameSchema = (postTitle, categoryId, introduction) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: postTitle || '',
    applicationCategory: 'GameApplication',
    applicationSubCategory: categoryId || '',
    description: introduction ? introduction.replace(/<[^>]*>?/g, '') : '',
    operatingSystem: ['ANDROID', 'iOS', 'WINDOWS PHONE']
  }

  return JSON.stringify(schema)
}

export function contentfulSchema (schema) {
  const parsedSchema = JSON.parse(schema)
  if (Array.isArray(parsedSchema)) {
    return parsedSchema.map((s) => {
      return JSON.stringify(s)
    })
  }

  return [schema]
}

export default breadcrumbSchema
